import { FormControl, Grid, TextField } from '@mui/material';
import Panel from '../../../components/UI/Panel';
import GenericSelectInput from './UI/GenericSelectInput';
import CustodianType from '../../../Models/Locations/custodianType';
import MultiSelectInput from './UI/MultiSelectInput';
import FacilityDepartmentAndPhysiciansInfo from './FacilityDepartmentAndPhysiciansInfo';
import DetailsPanel from '../../../common/DetailsPanel';
import styleClasses from '../../../assets/styles/panelStyles';

export default function FacilityType({
  formik,
  showPanel,
  custodianTypes,
  isEdit
}: Readonly<{
  formik: any;
  showPanel: boolean;
  custodianTypes: CustodianType[];
  isEdit?: boolean
}>) {

  const togglePressFacilityTypes = (r: string) => {
    let facilityTypes = [
      ...formik.values.facilityTypes,
    ];
    const recordIndex = facilityTypes.indexOf(r);
    if (recordIndex > -1) {
      facilityTypes = facilityTypes.filter((record) => record !== r);
    } else facilityTypes = [...facilityTypes, r];
    formik.setFieldValue(
      `facilityTypes`,
      facilityTypes,
    );
  };

  const handleFacilityTypeChange = (newFacilityTypes: any[]) => {
    const prevFacilityTypes = formik.values.facilityTypes;

    const removed = prevFacilityTypes.filter((r: any) => !newFacilityTypes.includes(r));

    if (removed.length > 0 && isEdit) {
      return;
    }

    formik.setFieldValue(`facilityTypes`, newFacilityTypes);
  };

  const content = (
    <Grid container spacing={2} direction="column" mx={1} px={1}>
      <Grid item xs={12} px={2}>
        <Panel headerText="Facility Types" styleClasses={styleClasses}>
          <Grid container spacing={2} mx={1} px={1}>
            <Grid item xs={4} px={2}>
              <GenericSelectInput
                hasError={
                  !!(formik?.touched?.facilityTypes && formik?.errors?.facilityTypes)
                }
                errorMsg={
                  formik?.touched?.facilityTypes && formik?.errors?.facilityTypes
                    ? formik?.errors?.facilityTypes
                    : ''
                }
                label="Select Facility Type(s)"
                name="facility-Types"
                onBlur={() => {
                  formik.setFieldTouched(`facilityTypes`, true);
                }}
                onChange={(value: any) => {
                  handleFacilityTypeChange(value)
                  formik.setFieldValue(`facilityTypes`, value);
                }}
                options={custodianTypes}
                value={formik.values.facilityTypes}
                multiple
                required={true}
              />
            </Grid>
            <Grid item xs={7} px={2}>
              <FormControl fullWidth>
                <TextField
                  name={'facilityTypeNotes'}
                  label="Notes"
                  placeholder="Notes"
                  multiline
                  variant="outlined"
                  inputMode={'text'}
                  inputProps={{ maxLength: 500 }}
                  value={formik?.values?.facilityTypeNotes}
                  onChange={(e: any) => {
                    formik?.setFieldValue(`facilityTypeNotes`, e.target.value);
                  }}
                  error={
                    !!(formik?.touched?.facilityTypeNotes &&
                      formik?.errors?.facilityTypeNotes)
                  }
                  helperText={
                    formik?.touched?.facilityTypeNotes &&
                      formik?.errors?.facilityTypeNotes
                      ? formik?.errors?.facilityTypeNotes
                      : ''
                  }
                  onBlur={() => {
                    formik?.setFieldTouched(`facilityTypeNotes`, true);
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} px={2}>
              <MultiSelectInput
                options={custodianTypes}
                errorMsg=''
                togglePress={togglePressFacilityTypes}
                values={formik?.values?.facilityTypes}
                showOnlySelected
              />
            </Grid>
          </Grid>
        </Panel>

      </Grid>

      <Grid item xs={12} px={2}>
        <FacilityDepartmentAndPhysiciansInfo formik={formik} />
      </Grid>
    </Grid>

  );
  return (
    <DetailsPanel title="Facility Details" content={content} showPanel={showPanel} />
  );
}

FacilityType.defaultProps = {
  showPanel: true,
};
